import { FormGroup } from '@angular/forms';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  ComponentFactoryResolver
} from '@angular/core';
import { isEmpty, find, filter } from 'lodash';
import { PaginationInstance } from 'ngx-pagination';
import { Subscription } from 'rxjs/Subscription';
import { ToastrService } from 'ngx-toastr';
import { LocalDataSource } from 'ng2-smart-table';
import {
  Actividad,
  ActividadCalendario,
  Categoria,
  Const,
  Microproceso,
  Proceso,
  Tarea,
  Tramite,
  TramiteDefaultCorto,
  HistorialMicroproceso,
  TramiteEstado,
  ConsultaTramite,
  Filtro,
  BaseControl,
  ParametroFiltro,
  EstructuraEspecifica,
  ValoresEspecificos,
  Option,
  DataIniciarSecundaria,
  TypeProcess,
  ConfirmComponent,
  TareaFinalizacion,
  ContextAutoSave,
  TaskEvent,
  ConfigFinishDefault,
  Static,
  Etapas,
} from '@app/shared';
import { GlobalNotifierService, Logger } from '@app/core';
import {
  FlowService,
  HelperFlowService,
  NotifierService,
  FlowConfig,
  FlowFormService
} from './shared';
import { SelectTramiteComponent } from './select-tramite/select-tramite.component';
import { FlowTitle } from './title/title.component';
import { SessionStorage } from 'ngx-webstorage';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { DynamicContentFormComponent } from '@app/forms/dynamic-content-form/dynamic-content-form.component';
import { TaskService } from './task/shared/task.service';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { Subject } from 'rxjs';

const log = new Logger('FlowComponent');

type Template = 'primary' | 'instances';
export class History {
  active = false;
  categories: Categoria[];
  processes: Proceso[];
  tramites: TramiteDefaultCorto[];
  category: Categoria;
  process: Proceso;
  tramite: TramiteDefaultCorto;
}

interface DataSourceTramite {
  id: number;
  fechaCreacion: Date;
  idExpediente: number;
  radicadoExpediente: string;
  estadoNombre: string;
  estado: TramiteEstado;
  radicadoSolicitud: string;
}

@Component({
  selector: 'iw-flow',
  templateUrl: './flow.component.html',
  styleUrls: ['./flow.component.scss'],
  providers: [FlowService, HelperFlowService, FlowFormService, TaskService]
})
export class FlowComponent implements OnInit, OnDestroy, AfterViewInit {
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  @SessionStorage() isDesignTask: string;
  // Define el mensaje de la alerta de carga dinamica
  messageAlertDynamic = '';
  // Contiene el tipo de proceso que se esta renderizando
  typeProcess: TypeProcess = 'process';
  // id secondary
  idTaskSecondary = -1;
  // id secondary
  idSecondary = -1;
  // Variable que determina si el formualrio está abierto
  openForm: Boolean = false;
  // Historial de las decisiones del usuario en los filtros de las tablas default
  history: History = new History();
  // Todos las instancias de un trámite(default)
  instances: ConsultaTramite[];
  // Instancia del trámite(default) seleccionado
  // La instancia puede ser un microproceso
  instance: Tramite | Microproceso;
  data: FlowTitle;
  // Contiene los campos de filtros de la consulta del tramite seleccionado
  filters: Filtro;
  // Suscripción a las notificaciones de los componentes hijos
  notifications: Subscription;
  // Configuración del paginador de las instancias
  pagination = Const.PAGINATION;
  configPagInstances: PaginationInstance = {
    id: 'instances',
    itemsPerPage: Const.PAGINATION.itemsPerPage,
    currentPage: 1
  };
  // Contiene la data a mostrar en la tabla e busqueda
  source: DataSourceTramite[] = [];
  // Contiene los controles de el formulario de filtros de la consulta
  controls: BaseControl<any>[] = [];
  // Contiene los controles de el formulario de cancelación de una secundaria
  controlsCancelSecondary: BaseControl<any>[] = [];
  // Datos para llenar la tabla deconsulta de instancias
  sourceData: LocalDataSource;
  // Configuración de la tabla
  settings = {};
  // Contiene los templates de los controles personalizados
  templates = {};
  // Contiene el formulario de filtros
  filterForm: FormGroup;
  // Estados del tramite
  readonly tramiteState = Const.STATUS_TRAMITE;
  // Determina si se esta ejecutando una petición al backend
  isLoading = {
    listInstances: false,
    createInstance: false,
    showInstance: false,
    finishTask: false,
    startSecondary: false,
    cancelSecondary: false,
    associationTramite: false,
    alertDynamic: false
  };
  // Muestra diferentes elementos
  show = {
    // Significado de la iconografía del flujo
    helperFlow: false,
    // Formulario de filtros de consulta
    filterForm: false,
  };
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  isDesign = 'compact';
  // Determina cuando la consulta se realizo por un filtro o sin filtro
  shearchFilter = false;
  historysMicroproces = {};
  historyMicroproce: HistorialMicroproceso[];
  idHistorySelect = 0;
  // Contiene el id de la primera actividad activada
  idActivityFirstActive = -1;
  // Contexto de las tareas para el auto guardado
  contextAutoSave: ContextAutoSave[] = [];
  // Contiene las etapas del tramite ( etapa actual y general)
  stage: Etapas;
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Plantilas disponibles para mostrar en el componente
  @ViewChild('primaryTpl') primaryTpl: TemplateRef<any>;
  @ViewChild('instancesTpl') instancesTpl: TemplateRef<any>;
  // Referencia de el selector personalizado para los formularios
  @ViewChild('ngSelectFilter') ngSelectTpl: TemplateRef<any>;
  // Referencia del modal de cancelacion de secundarias
  @ViewChild('modalCancelSecondary') modalCancelSecondary: TemplateRef<any>;
  // Componente select-tramite
  @ViewChild(SelectTramiteComponent) stcRef: SelectTramiteComponent;
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) confirmRef: ConfirmComponent;
  // Contenedor del formulario dinamico para auto guardado
  @ViewChild('componentFormAutoSave', { read: ViewContainerRef }) componentFormAutoSave: ViewContainerRef;
  // Referencia a el componente de renderizacion de formulario de tareas
  private componentRef: ComponentRef<DynamicContentFormComponent>;
  // Actividades de la instancia
  private _activities: Actividad[];
  // Plantilla que muestra el contenido del componente
  private _template: TemplateRef<any>;
  // Plantilla que muestra el contenido del componente
  private _templateF: TemplateRef<any>;
  // Controla si se muestra las tareas asociadas
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    private cdRef: ChangeDetectorRef,
    private fs: FlowService,
    private ns: NotifierService,
    private gns: GlobalNotifierService,
    public hfs: HelperFlowService,
    private toastr: ToastrService,
    private ffs: FlowFormService,
    private modalService: BsModalService,
    private cfr: ComponentFactoryResolver,
    private ts: TaskService,
    private sts: ScrollToService
  ) { }

  ngOnInit() {
    this.isDesign = this.isDesignTask ? this.isDesignTask : 'compact';
    this.templates['ngSelectTpl'] = this.ngSelectTpl;
    this.controlsCancelSecondary = this.ffs.getControlsCancelSecondary();
    // Escuchar todas las notificaciones de los elementos hijos del flujo
    this.notifications = this.ns.get().subscribe(n => {
      // Si se ejecutó el evento click en una tarea
      if (n.source === 'task' && n.eventTriggered === 'click') {
        this.clickedTask(n.data, n.action);
      } else if (n.source === 'title' && n.eventTriggered === 'change' && n.action === 'changeDesign') {
        this.isDesign = this.isDesignTask ? this.isDesignTask : 'compact';
      }
    });
  }

  ngAfterViewInit() {
    this.template = 'primary';
    this.history.active = true;
    // Vigilar los cambios que se producen en los selects de categoria, proceso y tramite.
    this.stcRef.dataObserver.subscribe(change => {
      if (change.target === 'category') {
        this.history.category = change.data as Categoria;
        this.instances = [];
        this.source = [];
        this.sourceData = null;
      }
      if (change.target === 'process') {
        this.history.process = change.data as Proceso;
      }
      if (change.target === 'tramite') {
        this.history.tramite = change.data as TramiteDefaultCorto;
      }
    });

    // Tratar las notificaciones globales en espera para este componente
    const globalNotifications = this.gns.get({
      destiny: 'FlowComponent'
    });
    globalNotifications.forEach(async (item, i) => {
      if (item.action === 'showFlow') {
        const data: ActividadCalendario = item.data;
        let idFlow = null;
        if (data.microproceso) {
          idFlow = data.microproceso;
        } else if (data.secundaria) {
          idFlow = data.secundaria;
          this.idSecondary = data.secundaria;
          this.typeProcess = 'secondary_process';
        } else {
          idFlow = data.id_tramite;
        }
        // Setear los selects de categoría, proceso y tramite
        await this.stcRef.reload('category', data.categoria);
        await this.stcRef.reload('process', data.proceso);
        await this.stcRef.reload('tramite', data.nombre_tramite);
        // Validar si el flujo no es un microproceso y mostrar flujo
        if (!data.microproceso && !data.secundaria) {
          this.getInstance(idFlow);
        } else {
          this.hfs.updateFlowHistory(data.id_tramite, false, false);
          this.runMicroProcess(idFlow);
        }
        // Eliminar este mensaje
        this.gns.delete(item.index);
        log.debug(`Consultando flujo ${idFlow} remitido desde el calendario de actividades.`);
      }
    });

  }

  ngOnDestroy() {
    // Eliminar suscripción a las notificaciones
    this.notifications.unsubscribe();
    this.destroy.next();
    this.destroy.complete();
  }

  set activities(v: Actividad[]) {
    this._activities = this.hfs.refineActivities(v, {
      filterByStatus: 'inactive'
    });
  }
  get activities(): Actividad[] {
    return this._activities;
  }

  /**
   * Define la plantilla que se debe mostrar.
   *
   * @memberof FlowComponent
   */
  set template(tpl: Template | TemplateRef<any>) {
    let template: TemplateRef<any>;
    if (!(tpl instanceof TemplateRef)) {
      switch (tpl) {
        case 'instances':
          template = this.instancesTpl;
          break;
        default:
          template = this.primaryTpl;
          break;
      }
    } else {
      template = tpl;
    }
    this._template = template;
    this.cdRef.detectChanges();
  }

  get template() {
    return this._template;
  }


  set templateF(tpl: TemplateRef<any>) {
    // let template: TemplateRef<any>;
    // template = tpl;
    this._templateF = tpl;
    this.cdRef.detectChanges();
  }

  get templateF() {
    return this._templateF;
  }

  /**
   * Evento que se ejecuta al seleccionar un trámite por default.
   * - Consulta las instancias del trámite por default.
   *
   * @memberof FlowComponent
   */
  async selectedDefaultTramite() {
    if (this.history.tramite && this.history.tramite.id) {
      this.isLoading.listInstances = true;
      this.instances = [];
      this.controls = [];
      this.filters = await this.fs.getFiltersShearchTramite(this.history.tramite.id);
      if (!this.filters || !this.filters.parametros || !this.filters.parametros.length) {
        this.shearchTramites(this.history.tramite.id);
      } else {

        if (this.filters.parametros.length) {
          await this.asyncForEach(this.filters.parametros, async (parameter: ParametroFiltro) => {
            if (parameter.campo['maestra'] && parameter.tipo_campo.nombre === 'ngSelect') {
              await this.loadingSelectsOptions(parameter);
            }
          });
        }
        this.controls = this.ffs.getFieldsFilterReportStructure(this.filters.parametros, this.templates);
        this.isLoading.listInstances = false;
        this.show.filterForm = true;
      }
      // this.backupDataSelectTramiteComponent();
      this.template = 'instances';
    } else {
      this.toastr.warning('Seleccione un tramite.', 'Información incompleta');
    }
  }

  /**
   * Guardar copia de los datos de SelectTramiteComponent
   *
   * @memberof FlowComponent
   */
  backupDataSelectTramiteComponent() {
    const backup = this.stcRef.getAll();
    for (const key in backup) {
      if (backup.hasOwnProperty(key)) {
        this.history[key] = backup[key];
      }
    }
  }

  /**
   * Evento que se ejecuta al seleccionar una instancia
   * del trámite por default.
   * - Setea la instancia global usada para generar el flujo.
   * - Setea las actividades del flujo.
   *
   * @param {(Tramite | Microproceso)} instance
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [changeCurrent=false]
   * @memberof FlowComponent
   */
  selectedInstance(
    instance: Tramite | Microproceso,
    goBack: boolean = false,
    clean: boolean = false,
    changeCurrent: boolean = false
  ) {
    this.hfs.updateFlowHistory(instance, goBack, clean, changeCurrent);
    this.instance = instance;
    if (instance && instance.actividades && instance.actividades.length) {
      for (const activity of instance.actividades) {
        if (activity.actividad_estado && activity.actividad_estado.nombre === Const.STATUS_ACTIVITY.pending) {
          this.idActivityFirstActive = activity.id;
          break;
        }
      }
    }
    this.activities = instance.actividades;
    this.data = this.hfs.getFlowTitle(instance);
    this.stage = null;
    this.fs.getStages(this.data.idTramite).subscribe(stage => {
      if (Object.entries(stage.etapa_actual).length > 0) {
        this.stage = stage;
      }
    });
  }

  /**
   * Retrocede un nivel en el flujo.
   *
   * @memberof FlowComponent
   */
  goBack() {
    if (this.idSecondary > 0) {
      if (this.idSecondary === this.instance.id) {
        this.typeProcess = 'process';
        this.idSecondary = -1;
        this.idTaskSecondary = -1;
      }
    }
    this.hfs.returnToPreviousFlow(
      // Generar el flujo de la instancia del trámite
      idTramite => {
        this.isLoading.showInstance = true;
        this.fs
          .getInstance(idTramite)
          .finally(() => {
            this.isLoading.showInstance = false;
          })
          .subscribe((instance: Tramite) => {
            this.selectedInstance(instance, true);
            this.typeProcess = 'process';
            this.idSecondary = -1;
            this.idTaskSecondary = -1;
          });
      },
      // Generar el flujo con el microproceso
      idMicroProcess => this.runMicroProcess(idMicroProcess, true)
    );
  }

  /**
   * Crea una nueva instancia utilizando como base
   * un trámite por default.
   *
   * @memberof FlowComponent
   */
  newInstance() {
    if (this.stcRef.tramite && this.stcRef.tramite.id) {
      this.isLoading.createInstance = true;
      this.fs
        .newInstance(this.stcRef.tramite.id)
        .finally(() => {
          this.isLoading.createInstance = false;
        })
        .subscribe(idInstance => {
            // Generar el flujo del la intancia del trámite
            this.getInstance(idInstance.id_tramite);
            log.debug('Create new instance: ', idInstance.id_tramite);
          },
          err => {
            this.isLoading.createInstance = false;
            log.debug('Create error new instance: ', err);
          }
        );
    } else {
      this.toastr.warning('Seleccione un tramite.', 'Información incompleta');
    }
  }

  /**
   * Consulta una instancia de un trámite y genera su flujo.
   *
   * @param {number} idInstance
   * @memberof FlowComponent
   */
  getInstance(idInstance: number, clean: boolean = true) {
    this.isLoading.showInstance = true;
    this.fs
      .getInstance(idInstance)
      .finally(() => {
        this.isLoading.showInstance = false;
      })
      .subscribe((instance: Tramite) => {
        this.selectedInstance(instance, false, clean);
      });
    this.template = 'primary';
  }

  /**
   * Controla el cambio de el select de versiones de microproceso
   *
   * @param {*} data
   * @memberof FlowComponent
   */
  changeSelectMicro(data: HistorialMicroproceso) {
    if (data) {
      this.runMicroProcess(Number(data.id), false, false, true);
    }
  }

  /**
   * Define si el proceso seleccionado esta finalizado
   *
   * @returns {boolean}
   * @memberof FlowComponent
   */
  selectProcessFinish(): boolean {
    let valid = false;
    if (this.idHistorySelect) {
      const item = find(this.historyMicroproce, {id: this.idHistorySelect});
      if (item) {
        valid = item.finalizado;
      }
    }
    return valid;
  }

  /**
   * Refresca el flujo actual
   *
   * @memberof FlowComponent
   */
  refreshFlow() {
    if (this.hfs.flowsHistory.length === 1) {
      this.isLoading.showInstance = true;
      this.fs
        .getInstance(this.hfs.flowsHistory[0])
        .finally(() => {
          this.isLoading.showInstance = false;
        })
        .subscribe((instance: Tramite) => {
          this.selectedInstance(instance, false, false, true);
        });
    } else {
      this.runMicroProcess(this.hfs.flowsHistory[this.hfs.flowsHistory.length - 1], false, false, true);
    }
  }

  /**
   * Setea en una variable el formulario creado para los filtros
   *
   * @param {FormGroup} form
   * @memberof FlowComponent
   */
  setForm(form: FormGroup) {
    this.filterForm = form;
  }

  /**
   * Controla la accion a realizar despues de la interacion del usuario en el formulario
   *
   * @param {boolean} filters
   * @memberof FlowComponent
   */
  searchTramiteFilter(filters: boolean) {
    this.isLoading.listInstances = true;
    this.instances = [];
    if (filters) {
      if (this.filterForm.valid) {
        this.shearchTramites(this.history.tramite.id, this.filterForm.value);
      }
    } else {
      this.shearchTramites(this.history.tramite.id);
    }
  }

  /**
   * Accion de retroceder en la vista
   *
   * @memberof FlowComponent
   */
  backInShearchTramite() {
    if (this.controls.length && !this.show.filterForm) {
      this.show.filterForm = true;
    } else {
      this.filterForm = null;
      this.controls = [];
      this.instances = [];
      this.template = this.primaryTpl;
    }
  }

  /**
   * Abre el modal de cancelacion de secundaria
   *
   * @memberof HeaderTitleTaskComponent
   */
  openModal() {
    this.modalRef = this.modalService.show(
      this.modalCancelSecondary,
      Object.assign({}, { class: 'modal-lg', ignoreBackdropClick: true })
    );
  }

  /**
   * Controla la accion de cancelar una secundaria
   *
   * @param {*} data
   * @memberof FlowComponent
   */
  cancelSecondary(data: any) {
    log.debug('cancelar secundaria', data);
    this.confirmRef.new({
      question: '¿Esta seguro de cancelar el proceso secundario?',
      labelConfirm: 'si',
      labelDecline: 'no'
    })
    .then(async res => {
      if (res) {
        if (this.idTaskSecondary && this.idTaskSecondary > 0) {
          this.modalRef.hide();
          this.isLoading.cancelSecondary = true;
          this.fs.cancelSecondary(this.idTaskSecondary, data.txtMotivo).then(() => {
            this.goBack();
            this.isLoading.cancelSecondary = false;
          }).catch(err => {
            log.debug(err);
            this.goBack();
            this.isLoading.cancelSecondary = false;
          });
        }
      }
    });
  }

  /**
   * Se ejecuta cuando detecta una notificación con un
   * evento click de una tarea.
   * - Si la tarea es un microproceso genera su flujo.
   *
   * @private
   * @param {any} data
   * @param {string} action
   * @memberof FlowComponent
   */
  private clickedTask(data: any, action: string) {
    switch (action) {
      // Cuando se va abrir un formulario fuera de la modal
      case 'openFormOutModal':
        this.backupDataSelectTramiteComponent();
        this.templateF = data.template;
        this.openForm = true;
        setTimeout(() => {
          this.sts.scrollTo({
            target: 'headerFlow'
          } as ScrollToConfigOptions);
        });
        break;
      // Mostrar cargar del flujo para accion de finalizar tarea
      case 'isLoadingFinishTask':
        this.isLoading.finishTask = true;
        this.openForm = false;
        this.templateF = null;
        break;
      case 'isLoadingAssociationTramite':
        this.isLoading.associationTramite = !this.isLoading.associationTramite;
        this.openForm = false;
        this.templateF = null;
        break;
      case 'closeLoadingFinishTask':
        this.isLoading.finishTask = false;
        break;
      // Cuando se va a finalizar la tarea
      case 'finishTask':
        this.isLoading.finishTask = false;
        this.refreshInstance();
        break;
      // Cuando se va abrir un microproceso
      case 'runMicroProcess':
        if (!isEmpty(data)) {
          this.runMicroProcess(data.task);
        }
        break;
      // Cuando se va abrir una secundaria
      case 'runSecondary':
        this.typeProcess = 'secondary_process';
        log.debug(data);
        if (!isEmpty(data)) {
          this.idTaskSecondary = data.task.id;
          this.runMicroProcess(data.task, false, false, false, true);
        }
        break;
      // Cuando se va a cerrar un formulario fuera de la modal
      case 'closeTaskForm':
/*         this.template = 'primary'; */
        this.openForm = false;
        this.templateF = null;
        break;
      // Cuando se necesita actualizar la informacion del flujo
      case 'updateTask':
        const activityCurrent: Actividad = this.instance.actividades.find((element: Actividad) => {
          return element.id === data.meta.idActivity;
        });
        activityCurrent.tareas[data.meta.index] = data;
        break;
      // Cuando se necesita refrescar el flujo
      case 'refreshFlow':
        this.refreshFlow();
        break;
      // Cuando se indica que se iniciaria un proceso secundario
      case 'startSecondary':
        this.startSecondary(data);
        break;
      // Cuando se ejecuta el auto guardar en tareas
      case 'autoSave':
        if (data && data.length) {
          this.contextAutoSave = data;
          this.finishTaskAutoSave();
        } else {
          if (this.isLoading.alertDynamic) {
            this.messageAlertDynamic = '';
            this.isLoading.alertDynamic = false;
          }
          if (!this.contextAutoSave && !this.contextAutoSave.length) {
            this.refreshFlow();
          }
        }
        break;
      // Cuando se desea mostrar la alerta de cargando con un mensaje dinamico
      case 'alertLoadDynamic':
        if (data && typeof data === 'string') {
          this.messageAlertDynamic = data;
          this.isLoading.alertDynamic = true;
          this.openForm = false;
          this.templateF = null;
        } else {
          this.messageAlertDynamic = '';
          this.isLoading.alertDynamic = false;
        }
        break;
    }
  }

  /**
   * Se encarga de iniciar un proceso secundario en el flujo
   *
   * @private
   * @param {DataIniciarSecundaria} data
   * @memberof FlowComponent
   */
  private startSecondary(data: DataIniciarSecundaria) {
    this.isLoading.startSecondary = true;
    const dataForm = {
      tarea: data.tarea_id
    };
    this.fs.startSecondary(data.id, dataForm).then(() => {
      this.isLoading.startSecondary = false;
      this.refreshFlow();
    }).catch(error => {
      log.debug(error);
      this.isLoading.startSecondary = false;
      this.refreshFlow();
    });
  }

  /**
   * Consulta un microproceso y crea su flujo.
   *
   * @private
   * @param {(Tarea | number)} task
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [changeCurrent=false]
   * @param {boolean} [secondary=false]
   * @memberof FlowComponent
   */
  private async runMicroProcess(
    task: Tarea | number,
    goBack: boolean = false,
    clean: boolean = false,
    changeCurrent: boolean = false,
    secondary: boolean = false
  ) {
    this.isLoading.showInstance = true;
    let idTask = typeof task === 'number' ? task : task.id;
    if (typeof task === 'number') {
      idTask = task;
    } else if (task && task.historial_microproceso) {
      let ordenMax = 0;
      task.historial_microproceso.forEach(history => {
        if (history.orden > ordenMax) {
          ordenMax = history.orden;
          idTask = history.id;
        }
      });
    } else {
      idTask = task.id;
    }
    if (typeof task === 'object') {
      if (!this.historysMicroproces[idTask]) {
        this.historysMicroproces[idTask] = task.id;
      }
      this.historyMicroproce = task.historial_microproceso;
    } else {
      if (this.historysMicroproces[idTask]) {
        this.historyMicroproce = await this.fs.getHistoryMicroproces(this.historysMicroproces[idTask]);
        if (this.historyMicroproce && this.historyMicroproce.length) {
          this.historyMicroproce.forEach(history => {
            if (!this.historysMicroproces[history.id]) {
              this.historysMicroproces[history.id] = this.historysMicroproces[idTask];
            }
          });
        }
      }
    }
    if (this.historyMicroproce && this.historyMicroproce.length) {
      this.historyMicroproce.sort((a, b) => b.orden - a.orden);
    }
    this.idHistorySelect = idTask;
    log.debug('idhistory: ', this.idHistorySelect);
    this.fs
      .getMicroProcess(idTask)
      .finally(() => {
        this.isLoading.showInstance = false;
      })
      .subscribe((instance: Microproceso) => {
        if (secondary) {
          this.idSecondary = instance.id;
        }
        this.selectedInstance(instance, goBack, clean, changeCurrent);
      });
    this.template = 'primary';
  }

  /**
   * Volver a consultar la instancia actual y mostrar su flujo.
   *
   * @private
   * @memberof FlowComponent
   */
  private refreshInstance() {
    this.hfs.reloadFlow(
      currentInstance => this.getInstance(currentInstance),
      currentInstance => this.runMicroProcess(currentInstance, false)
    );
  }

  /**
   * Consulta los tramites
   *
   * @private
   * @param {number} idTramite
   * @param {*} [filters]
   * @memberof FlowComponent
   */
  private shearchTramites(idTramite: number, filters?: any) {
    this.shearchFilter = filters ? true : false;
    this.fs
      .getInstanceDefaultTramites(idTramite, filters)
      .subscribe(data => {
        if (data.length) {
          data.sort((a, b) => a.id - b.id);
          this.instances = data;
        }
        this.loadDinamicFieldFromTable();
      });
  }

  /**
   * Genera las columns de los campos dinamicos en la tabla
   *
   * @private
   * @memberof FlowComponent
   */
  private loadDinamicFieldFromTable() {
    const configTable = new FlowConfig();
    this.settings = {};
    if (this.instances && this.instances.length) {
      if (this.instances[0].campos && this.instances[0].campos.length) {
        this.instances.forEach(cd => {
          cd.campos.sort((a, b) => a.orden - b.orden);
        });
        this.instances[0].campos.forEach(field => {
          configTable.generateColumn(field.orden + ' ', field.nombre_parametro);
        });
      }
    }
    this.settings = configTable.settings;
    this.loadTableShearchTramite();
  }

  /**
   * Carga la informacion de cada tramite consultado en la tabla
   *
   * @private
   * @memberof FlowComponent
   */
  private loadTableShearchTramite() {
    this.source = [];
    if (this.instances && this.instances.length) {
      this.instances.forEach(instance => {
        const d: DataSourceTramite = {
          id: instance.id,
          fechaCreacion: instance.expediente.fecha_creacion,
          idExpediente: instance.expediente.id,
          radicadoExpediente: instance.expediente.codigo,
          estadoNombre: instance.expediente.expediente_estado.nombre,
          estado: instance.expediente.expediente_estado,
          radicadoSolicitud: instance.expediente.radicado_solicitud
        };
        if (instance.campos && instance.campos.length) {
          instance.campos.forEach(field => {
            d[field.orden + ' '] = field.valor;
            if (field['formato_fecha']) {
              d['formato_fecha'] = field['formato_fecha'];
            }
          });
        }
        this.source.push(d);
      });
    }
    this.sourceData = new LocalDataSource(this.source);
    this.sourceData.refresh();
    this.isLoading.listInstances = false;
    this.show.filterForm = false;
  }

  /**
   * Carga la maestra seleccionada para un campo de filtros de tipo ngSeelect
   *
   * @private
   * @param {ParametroFiltro} field
   * @returns {Promise<any>}
   * @memberof FlowComponent
   */
  private async loadingSelectsOptions(
    field: ParametroFiltro,
  ): Promise<any> {
    return new Promise(async (resolve) => {
      const columnsMaster: Array<Option> = [];
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        let specificEstructure: EstructuraEspecifica;
        let columns: ValoresEspecificos[] = [];

        specificEstructure = this.loadingColumnsStructureMaster(
          field.campo['maestra']['id'],
          field.campo['maestra']['columnas_seleccionadas']
        );

        columns = await this.fs.getColumnsSpecificMasterTable(specificEstructure);
        if (columns.length) {
          columns.forEach(column => {
            let labelSelect = '';

            field.campo['maestra']['columnas_seleccionadas'].forEach((col: number, index: any) => {
              if (index > 0) {
                labelSelect += ' / ';
              }
              if (column.valores[col]) {
                labelSelect += column.valores[col] ;
              } else {
                labelSelect += 'No aplica';
              }
            });
            columnsMaster.push({value: column.id, key: labelSelect});
          });
        }
      }
      field['options'] = columnsMaster;
      resolve(true);
    });
  }

  /**
   * Ejecuta un for de forma sincronica
   *
   * @private
   * @param {Array<any>} array
   * @param {*} callback
   * @memberof FlowComponent
   */
  private async asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
      continue;
    }
  }

  /**
   * Genera la estructura de consulta de la maestra con las columnas seleccionadas
   *
   * @private
   * @param {string} idMaster
   * @param {Array<any>} columns
   * @returns {EstructuraEspecifica}
   * @memberof FlowComponent
   */
  private loadingColumnsStructureMaster(idMaster: string, columns: Array<any>): EstructuraEspecifica {
    const colsDependence = {};
    const specificStructure: EstructuraEspecifica = {
      maestra: String(idMaster),
      columnas: [],
      dependencia: []
    };
    columns.forEach((col: string, index: number) => {
      const cols = col.split('_');
      const column = Number(cols[0]);
      if (cols.length === 1) {
        specificStructure.columnas.push(column + ' ');
      } else if (cols.length !== 0) {
        cols.splice(0, 1);
        col = '';
        cols.forEach((c, i) => {
          col += c;
          if (i < (cols.length - 1)) {
            col += '_';
          }
        });
        if (colsDependence[column]) {
          colsDependence[column].push(col);
        } else {
          colsDependence[column] = [col];
        }
      }
    });
    if (Object.keys(colsDependence).length) {
      Object.keys(colsDependence).forEach(key => {
        specificStructure.dependencia.push(
          this.loadingColumnsStructureMaster(key + ' ', colsDependence[key])
        );
      });
    }
    return specificStructure;
  }

  /**
   * Prepara la tarea a ejecutar el auto guardado
   *
   * @private
   * @param {ContextAutoSave} data
   * @memberof FlowComponent
   */
  private finishAutoSave(data: ContextAutoSave) {
    if (this.messageAlertDynamic !== data.messageLoad) {
      this.messageAlertDynamic = data.messageLoad;
    }
    if (!this.isLoading.alertDynamic) {
      this.isLoading.alertDynamic = true;
    }
    if (this.componentFormAutoSave) {
      this.componentFormAutoSave.clear();
    }
    if (data.task.tarea_tipo.nombre === Const.TYPES_TASK.form) {
      const factory = this.cfr.resolveComponentFactory(DynamicContentFormComponent);
      this.componentRef = this.componentFormAutoSave.createComponent(factory);
      this.componentRef.instance.task = data.task;
      this.componentRef.instance.context = {
        task: data.task,
        typeProcess: data.typeProcess
      };
      this.componentRef.instance.autoSave = true;
      this.componentRef.instance.event.subscribe((event: any)  => this.manageEvent(event));
    } else if (data.task.tarea_tipo.nombre === Const.TYPES_TASK.none) {
      const dataEvent: ConfigFinishDefault = {
        tarea: data.task.id
      };
      dataEvent['task'] = data.task;
      this.manageEvent({
        type: 'finishAutoSave',
        data: dataEvent
      });
    } else {
      this.finishTaskAutoSave();
    }
  }

  /**
   * Controla los eventos notificados por el componente de renderizacion de formulario dinamico
   * para la tarea actual ejecutando auto guardado
   *
   * @param {TaskEvent} e
   * @memberof FlowComponent
   */
  manageEvent(e: TaskEvent) {
    let skipFinish = false;
    if (e.hasOwnProperty('params')) {
      skipFinish = e.params.hasOwnProperty('skip') ? e.params.skip : false;
    }
    switch (e.type) {
      case 'finishAutoSave':
        this.componentFormAutoSave.clear();
        this.finish(e.data, skipFinish);
        break;
    }
  }

  /**
   * Ejecuta la finalizacion de la tarea
   *
   * @param {*} data
   * @param {boolean} [_skip=false]
   * @memberof FlowComponent
   */
  async finish(data: any, _skip: boolean = false) {
    // Inicio finalizacion tarea
    let isFinished: boolean;
    let autoSaved = false;
    const taskFinish: Tarea = data.task;
    switch (taskFinish.tarea_tipo.nombre) {
      // Ninguna, condición y forma especifica
      case Const.TYPES_TASK.none:
      case Const.TYPES_TASK.condition:
      case Const.TYPES_TASK.form:
        if (data['id_opciones'] && data['id_opciones'].length) {
          let f = true;
          isFinished = true;
          await this.asyncForEach(data['id_opciones'], async (el: number) => {
            const d: ConfigFinishDefault = {
              tarea: data['tarea'],
              id_opcion: el
            };
            f = await this.ts.finishDefault(d);
            if (!f) {
              isFinished = false;
            }
          });
        } else {
          isFinished = await this.ts.finishDefault(data as ConfigFinishDefault);
        }
        break;
    }
    if (isFinished) {
      let automaticEndings: TareaFinalizacion[];
      if (data['id_opciones'] && data['id_opciones'].length) {
        automaticEndings = filter(
          taskFinish.tarea_finalizacion,
          f => data['id_opciones'].indexOf(f.opcion) && f.parametros['auto_guardado'] && f.tarea_destino
        );
      } else {
        automaticEndings = filter(
          taskFinish.tarea_finalizacion, f => f.parametros['auto_guardado'] && f.tarea_destino
        );
      }
      // Auto guardado de tareas
      if (automaticEndings.length) {
        autoSaved = true;
        await Static.asyncForEach(automaticEndings, async endings => {
          if (endings.tarea_destino) {
            const task = await this.ts.getInstanceTask(endings.tarea_destino);
            // Obtener el formulario para renderizar la tarea
            let formType = null;
            const name = task.tarea_tipo.nombre === Const.TYPES_TASK.form ?
                    task ?
                      task.tarea_forma ?
                        task.tarea_forma.length ?
                          task.tarea_forma[0].nombre
                        : undefined
                      : undefined
                    : undefined
                   : undefined;
            if (task.tarea_tipo.nombre !== Const.TYPES_TASK.microProcess) {
              const forma: Array<any> = new Array(task.tarea_forma);
              if (forma[0].length > 0) {
                formType = this.hfs.getFormType(task.tarea_tipo.nombre, name, task.tarea_forma[0].forma_especifica);
              } else {
                formType = this.hfs.getFormType(task.tarea_tipo.nombre, name, true);
              }
            }
            task.meta = {
              idActivity: task['tarea_actividad']['id'] ? task['tarea_actividad']['id'] : null,
              formType: formType
            };
            this.contextAutoSave.push({
              idTaskOrigin: endings.tarea_inicio,
              task: task,
              typeProcess: this.typeProcess,
              messageLoad: endings.parametros['auto_guardado']
            });
          }
        });
      }
      this.finishTaskAutoSave();
    } else {
      this.messageAlertDynamic = '';
      this.isLoading.alertDynamic = false;
    }
  }

  /**
   * Ejecuta la finalizacion automatica de una tarea en cola
   *
   * @private
   * @memberof FlowComponent
   */
  private finishTaskAutoSave() {
    if (this.contextAutoSave && this.contextAutoSave.length) {
      const dataAutoSave = Static.copyObjet(this.contextAutoSave[0]);
      this.contextAutoSave.splice(0, 1);
      this.finishAutoSave(dataAutoSave);
    } else {
      this.messageAlertDynamic = '';
      this.isLoading.alertDynamic = false;
      this.refreshFlow();
    }
  }

} // End class



// WEBPACK FOOTER //
// ./src/app/flow/flow.component.ts